module.exports = __webpack_public_path__ + "img/marketing-light.f33fc06c.png";